<template>
  <div>
    <a-form-model
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      style="margin-top: 10px;"
      :rules="rules"
      ref="ruleForm"
      :key="keyChange"
    >
      <a-form-model-item label="Type / Loại" prop="type">
        <a-select v-model="form.type">
          <a-select-option value="HOLIDAY">
            Holiday / Nghỉ lễ
          </a-select-option>
          <a-select-option value="COMPENSATORY_LEAVE">
            Compensatory day / Nghỉ bù
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="Title / Tiêu đề" prop="name">
        <a-input v-model="form.name" placeholder="Write title..." />
      </a-form-model-item>
      <!-- <a-form-model-item label="Năm thực hiện" prop="year">
        <a-select
          placeholder="Chọn năm thực hiện"
          v-model="form.year"
          style="width: 100%;"
        >
          <a-select-option v-for="item in listYears" :key="item">
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-model-item> -->
      <a-form-model-item label="Date / Ngày nghỉ lễ" prop="rangeDate">
        <a-range-picker
          format="DD/MM/YYYY"
          style="width: 100%;"
          @change="onChangeRangeDate"
        />
      </a-form-model-item>
      <!-- <a-form-model-item label="Ngày bắt đầu" prop="startDate">
        <a-date-picker
          placeholder="Chọn ngày..."
          v-model="form.startDate"
          style="width: 100%;"
          format="DD/MM/YYYY"
          @change="calTotalDay"
        />
      </a-form-model-item>
      <a-form-model-item label="Ngày kết thúc" prop="endDate">
        <a-date-picker
          placeholder="Chọn ngày..."
          v-model="form.endDate"
          style="width: 100%;"
          format="DD/MM/YYYY"
          @change="calTotalDay"
        />
      </a-form-model-item> -->
      <a-form-model-item label="Duration / Số ngày nghỉ" prop="duration">
        <a-input-number
          v-model="form.duration"
          placeholder="Enter number..."
          :formatter="
            (value) =>
              +value >= 0
                ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : undefined
          "
          :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
          style="width: 100%;"
        />
      </a-form-model-item>

      <a-form-model-item label="Description / Mô tả">
        <VueEditor
          class="ict24h-editor"
          :editor-toolbar="customToolbar"
          placeholder="Enter description..."
          v-model="form.description"
        />
      </a-form-model-item>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 10px;" @click="close">
        Close
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loading">
        Add New
      </a-button>
    </div>
  </div>
</template>
<script>
import query from "../constant/query";
import moment from "moment";

function range(start, end) {
  var ans = [];

  for (let i = start; i <= end; i++) {
    ans.push(i);
  }
  return ans;
}

const nowYear = new Date().getFullYear();
const listYears = range(+nowYear - 5, +nowYear + 5);
const rules = {
  type: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
  name: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
  duration: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
  rangeDate: [
    { required: true, message: "Required / Thông tin không được bỏ trống" },
  ],
  // startDate: [{ required: true, message: "Thông tin không được bỏ trống" }],
  // endDate: [{ required: true, message: "Thông tin không được bỏ trống" }],
};
const defaultForm = {
  startDate: undefined,
  endDate: undefined,
  type: "HOLIDAY",
};

export default {
  props: {
    close: { type: Function, required: true },
    refreshAfterCreated: { type: Function, required: true },
  },
  data() {
    return {
      listYears,
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: { ...defaultForm },
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loading: false,
      keyChange: 0,
    };
  },
  methods: {
    moment,
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onCreatedHoliday();
        } else {
          return false;
        }
      });
    },
    onCreatedHoliday() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: query.createHoliday,
          variables: {
            ...this.form,
            startDate: this.form.startDate
              ? moment(this.form.startDate).set({
                  hour: 0,
                  minute: 0,
                  second: 0,
                })
              : undefined,
            endDate: this.form.endDate
              ? moment(this.form.endDate).set({
                  hour: 23,
                  minute: 59,
                  second: 59,
                })
              : undefined,
            year: this.form.startDate
              ? +new Date(this.form.startDate).getFullYear()
              : undefined,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
          this.loading = false;
          this.form = { ...defaultForm };
          if (data?.createHoliday?.id) {
            this.refreshAfterCreated(data.createHoliday);
          }
          this.keyChange += 1;
        })
        .catch((err) => {
          this.loading = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Thêm thông tin không thành công", err);
        });
    },
    calTotalDay() {
      if (this.form.startDate && this.form.endDate) {
        const startDate = moment(this.form.startDate).set({
          hour: 0,
          minute: 0,
        });
        const endDate = moment(this.form.endDate).set({ hour: 23, minute: 59 });
        this.$set(this.form, "duration", endDate.diff(startDate, "days") + 1);
      }
    },
    onChangeRangeDate(arrayDate) {
      if (arrayDate) {
        const startDate = arrayDate[0];
        const endDate = arrayDate[1];
        this.$set(this.form, "rangeDate", arrayDate);
        this.$set(this.form, "startDate", startDate);
        this.$set(this.form, "endDate", endDate);
        this.calTotalDay();
      }
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
